<template>
  <div id="Lgx02667670704743478461196">
    <div class="relative flex main-border rounded-lg bg-dark px-10 pb-10">
      <img
        src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/02667670704743478461196/graphic.png"
        alt="Logo"
        draggable="false"
        width="100%"
        height="100%"
      />

      <span
        class="component main-border bg-light rounded-lg"
        style="width: 12.5%; height: 17.5%; bottom: 58%; left: 43.65%"
        @click="componentSelectingIndex = 0"
      >
        <font-awesome-icon
          :icon="getIconForComponentAnswer(components[0].value)"
          class="h-24 w-24"
          :style="{
            color: components[0].score === true ? '#30b851' : components[0].score === false ? '#c93738' : '#ffc600',
            zIndex: 10,
          }"
        />
      </span>

      <span
        class="component main-border bg-light rounded-lg"
        style="width: 12.5%; height: 17.5%; bottom: 35.5%; left: 43.65%"
        @click="componentSelectingIndex = 1"
      >
        <font-awesome-icon
          :icon="getIconForComponentAnswer(components[1].value)"
          class="h-24 w-24"
          :style="{
            color: components[1].score === true ? '#30b851' : components[1].score === false ? '#c93738' : '#ffc600',
            zIndex: 10,
          }"
        />
      </span>

      <span
        class="component main-border bg-light rounded-lg"
        style="width: 12.5%; height: 17.5%; bottom: 45.5%; left: 13.75%"
        @click="componentSelectingIndex = 2"
      >
        <font-awesome-icon
          :icon="getIconForComponentAnswer(components[2].value)"
          class="h-24 w-24"
          :style="{
            color: components[2].score === true ? '#30b851' : components[2].score === false ? '#c93738' : '#ffc600',
            zIndex: 10,
          }"
        />
      </span>

      <span
        class="component main-border bg-light rounded-lg"
        style="width: 12.5%; height: 17.5%; bottom: 5.5%; left: 43.65%"
        @click="componentSelectingIndex = 3"
      >
        <font-awesome-icon
          :icon="getIconForComponentAnswer(components[3].value)"
          class="h-24 w-24"
          :style="{
            color: components[3].score === true ? '#30b851' : components[3].score === false ? '#c93738' : '#ffc600',
            zIndex: 10,
          }"
        />
      </span>

      <span
        class="component main-border bg-light rounded-lg"
        style="width: 12.5%; height: 17.5%; bottom: 51%; left: 83.5%"
        @click="componentSelectingIndex = 4"
      >
        <font-awesome-icon
          :icon="getIconForComponentAnswer(components[4].value)"
          class="h-24 w-24"
          :style="{
            color: components[4].score === true ? '#30b851' : components[4].score === false ? '#c93738' : '#ffc600',
            zIndex: 10,
          }"
        />
      </span>
    </div>

    <movable-popup
      refVal="componentSelectorPopup"
      title="Components"
      :active="componentSelectingIndex !== -1"
      v-on:close="componentSelectingIndex = -1"
      style="width: fit-content"
    >
      <template v-slot:content>
        <div class="flex flex-col gap-3">
          <button
            v-for="(icon, index) in icons"
            :key="index"
            class="bg-dark flex items-center text-white font-semibold text-xl gap-4 main-border p-4 w-full h-fit cursor-pointer"
            @click="
              () => {
                components[componentSelectingIndex].value = icon.name;
                components[componentSelectingIndex].score = null;
                componentSelectingIndex = -1;
              }
            "
          >
            <font-awesome-icon :icon="icon.icon" class="h-8 w-8" style="color: #ffc600" />
            {{ icon.name }}
          </button>
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      componentSelectingIndex: -1,

      icons: [
        {
          name: 'SWITCH',
          icon: 'fa-solid fa-ethernet',
        },
        {
          name: 'WAP',
          icon: 'fa-solid fa-wifi',
        },
        {
          name: 'HUB',
          icon: 'fa-solid fa-network-wired',
        },
        {
          name: 'WIRELESS RANGE EXTENDER',
          icon: 'fa-solid fa-signal-stream',
        },
        {
          name: 'ROUTER',
          icon: 'fa-solid fa-router',
        },
        {
          name: 'FIREWALL',
          icon: 'fa-solid fa-block-brick-fire',
        },
      ],

      components: [
        {
          value: '',
          answer: 'FIREWALL',
          score: null,
        },
        {
          value: '',
          answer: 'ROUTER',
          score: null,
        },
        {
          value: '',
          answer: 'SWITCH',
          score: null,
        },
        {
          value: '',
          answer: 'WIRELESS RANGE EXTENDER',
          score: null,
        },
        {
          value: '',
          answer: 'SWITCH',
          score: null,
        },
      ],
    };
  },
  methods: {
    getIconForComponentAnswer(answer) {
      const iconObject = this.icons.find((icon) => icon.name === answer);
      return iconObject ? iconObject.icon : 'fa-solid fa-question';
    },
    markSimulation() {
      let totalScore = 0;

      this.components.forEach((field, index) => {
        if (field.value === field.answer) {
          this.components[index].score = true;
          totalScore++;
        } else {
          this.components[index].score = false;
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    vSelect,
    MovablePopup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
#Lgx02667670704743478461196 {
  .component {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto;
  }
}
</style>
